var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.618 20.0608C33.618 20.4654 33.4347 20.8474 33.1193 21.1008L22.9747 29.2454C22.4007 29.7068 21.5613 29.6148 21.1 29.0408C20.6387 28.4668 20.7307 27.6274 21.3047 27.1661L30.1567 20.0594L21.1827 12.8334C20.6093 12.3714 20.5187 11.5321 20.98 10.9588C21.442 10.3854 22.2813 10.2948 22.8547 10.7561L33.1207 19.0221C33.4347 19.2754 33.618 19.6568 33.618 20.0608Z",
    fill: "#515151"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5427 20.0001C33.5427 20.7367 32.946 21.3334 32.2093 21.3334H7.71534C6.97867 21.3334 6.382 20.7367 6.382 20.0001C6.382 19.2634 6.97867 18.6667 7.71534 18.6667H32.2093C32.946 18.6667 33.5427 19.2634 33.5427 20.0001Z",
    fill: "#515151"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.e580a6cb9a071ba09179c5cded940d88.svg";
export { ForwardRef as ReactComponent };